import { useEffect } from 'react';
import { isMacPlatform } from '@utils/is-mac-platform';

import type { UseMagicSearchShortcutParams } from './magic-search.type';

const SHORTCUT_KEY = 'k';

// Without preventDefault, Ctrl+K reaches the browser's own search bar.
export const useMagicSearchShortcut = ({ isEnabled, onToggle }: UseMagicSearchShortcutParams) => {
  useEffect(() => {
    if (!isEnabled) return;
    const isMac = isMacPlatform();

    const handleKeyDown = (event: KeyboardEvent) => {
      const hasModifier = isMac ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey;
      if (!hasModifier || event.altKey || event.shiftKey || event.key.toLowerCase() !== SHORTCUT_KEY) return;
      event.preventDefault();
      onToggle();
    };

    globalThis.addEventListener('keydown', handleKeyDown);
    return () => globalThis.removeEventListener('keydown', handleKeyDown);
  }, [isEnabled, onToggle]);
};
